import shopifyGenericDefaults from '../shopify-dawn-generic/config.js';

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyGenericDefaults,
  infiniteScrollEnabled: false,
  pagination: {
    centralRange: window.innerWidth < 640 ? 1 : 2,
  },
};
